module.exports = __webpack_public_path__ + "img/矫治器加工.c28d3871.png";